import React from 'react'

import RCgs_coins_add from 'src/assets/gs-icons/gs_coins_add.svg?react'
import RCgs_circle_check from 'src/assets/gs-icons/gs_circle_check.svg?react'
import RCgs_home_personal_feed from 'src/assets/gs-icons/gs_home_personal_feed.svg?react'
import RCgs_sleep from 'src/assets/gs-icons/gs_sleep.svg?react'
import RCgs_arrow_right_circle from 'src/assets/gs-icons/gs_arrow_right_circle.svg?react'
import RCgs_circle_info from 'src/assets/gs-icons/gs_circle_info.svg?react'
import RCgs_paper_plane_top_right_1 from 'src/assets/gs-icons/gs_paper_plane_top_right_1.svg?react'
import RCgs_square_arrow_top_right_2 from 'src/assets/gs-icons/gs_square_arrow_top_right_2.svg?react'
import RCgs_arrows_repeat_right_left_off from 'src/assets/gs-icons/gs_arrows_repeat_right_left_off.svg?react'
import RCgs_circle_x_1 from 'src/assets/gs-icons/gs_circle_x_1.svg?react'
import RCgs_paper_plane_top_right from 'src/assets/gs-icons/gs_paper_plane_top_right.svg?react'
import RCgs_square_arrow_top_right from 'src/assets/gs-icons/gs_square_arrow_top_right.svg?react'
import RCgs_arrows_repeat_right_left from 'src/assets/gs-icons/gs_arrows_repeat_right_left.svg?react'
import RCgs_circle_x from 'src/assets/gs-icons/gs_circle_x.svg?react'
import RCgs_pencil from 'src/assets/gs-icons/gs_pencil.svg?react'
import RCgs_square_behind_square_2 from 'src/assets/gs-icons/gs_square_behind_square_2.svg?react'
import RCgs_bubble_annotation_4 from 'src/assets/gs-icons/gs_bubble_annotation_4.svg?react'
import RCgs_clock_blue from 'src/assets/gs-icons/gs_clock_blue.svg?react'
import RCgs_people_add_2 from 'src/assets/gs-icons/gs_people_add_2.svg?react'
import RCgs_tag from 'src/assets/gs-icons/gs_tag.svg?react'
import RCgs_buildings from 'src/assets/gs-icons/gs_buildings.svg?react'
import RCgs_cross_large from 'src/assets/gs-icons/gs_cross_large.svg?react'
import RCgs_people_add from 'src/assets/gs-icons/gs_people_add.svg?react'
import RCgs_team from 'src/assets/gs-icons/gs_team.svg?react'
import RCgs_buildings_add from 'src/assets/gs-icons/gs_buildings_add.svg?react'
import RCgs_donut from 'src/assets/gs-icons/gs_donut.svg?react'
import RCgs_people_added from 'src/assets/gs-icons/gs_people_added.svg?react'
import RCgs_triangle_exclamation from 'src/assets/gs-icons/gs_triangle_exclamation.svg?react'
import RCgs_calendar_edit from 'src/assets/gs-icons/gs_calendar_edit.svg?react'
import RCgs_eye_open from 'src/assets/gs-icons/gs_eye_open.svg?react'
import RCgs_people from 'src/assets/gs-icons/gs_people.svg?react'
import RCgs_wallet_3 from 'src/assets/gs-icons/gs_wallet_3.svg?react'
import RCgs_calender_remove from 'src/assets/gs-icons/gs_calender_remove.svg?react'
import RCgs_file_download from 'src/assets/gs-icons/gs_file_download.svg?react'
import RCgs_radio_active from 'src/assets/gs-icons/gs_radio_active.svg?react'
import RCgs_chevron_right_small from 'src/assets/gs-icons/gs_chevron_right_small.svg?react'
import RCgs_group_3 from 'src/assets/gs-icons/gs_group_3.svg?react'
import RCgs_radio_default from 'src/assets/gs-icons/gs_radio_default.svg?react'
import RCgs_notepad from 'src/assets/gs-icons/gs_notepad.svg?react'
import RCgs_icon_clipboard from 'src/assets/gs-icons/gs_icon_clipboard.svg?react'
import RCgs_bank from 'src/assets/gs-icons/gs_bank.svg?react'
import RCgs_bgc from 'src/assets/gs-icons/gs_bgc.svg?react'
import RCgs_bookmark from 'src/assets/gs-icons/gs_bookmark.svg?react'
import RCgs_check from 'src/assets/gs-icons/gs_check.svg?react'
import RCgs_driver_back from 'src/assets/gs-icons/gs_driver_back.svg?react'
import RCgs_driver_front from 'src/assets/gs-icons/gs_driver_front.svg?react'
import RCgs_recollect_purple from 'src/assets/gs-icons/gs_recollect_purple.svg?react'
import RCgs_recollect from 'src/assets/gs-icons/gs_recollect.svg?react'
import RCgs_zap from 'src/assets/gs-icons/gs_zap.svg?react'
import RCgs_clock_orange from 'src/assets/gs-icons/gs_clock_orange.svg?react'
import RCgs_tasks from 'src/assets/gs-icons/gs_tasks.svg?react'
import RCgs_visa from 'src/assets/gs-icons/gs_visa.svg?react'
import RCgs_mastercard from 'src/assets/gs-icons/gs_mastercard.svg?react'
import RCgs_icon_camera_access_denied from 'src/assets/gs-icons/gs_icon_camera_access_denied.svg?react'

type GSIconName =
  | 'gs_coins_add'
  | 'gs_circle_check'
  | 'gs_home_personal_feed'
  | 'gs_sleep'
  | 'gs_arrow_right_circle'
  | 'gs_circle_info'
  | 'gs_paper_plane_top_right_1'
  | 'gs_square_arrow_top_right_2'
  | 'gs_arrows_repeat_right_left_off'
  | 'gs_circle_x_1'
  | 'gs_paper_plane_top_right'
  | 'gs_square_arrow_top_right'
  | 'gs_arrows_repeat_right_left'
  | 'gs_circle_x'
  | 'gs_pencil'
  | 'gs_square_behind_square_2'
  | 'gs_bubble_annotation_4'
  | 'gs_clock_blue'
  | 'gs_people_add_2'
  | 'gs_tag'
  | 'gs_buildings'
  | 'gs_cross_large'
  | 'gs_people_add'
  | 'gs_team'
  | 'gs_buildings_add'
  | 'gs_donut'
  | 'gs_people_added'
  | 'gs_triangle_exclamation'
  | 'gs_calendar_edit'
  | 'gs_eye_open'
  | 'gs_people'
  | 'gs_wallet_3'
  | 'gs_calender_remove'
  | 'gs_file_download'
  | 'gs_radio_active'
  | 'gs_chevron_right_small'
  | 'gs_group_3'
  | 'gs_radio_default'
  | 'gs_notepad'
  | 'gs_icon_clipboard'
  | 'gs_bank'
  | 'gs_bgc'
  | 'gs_bookmark'
  | 'gs_check'
  | 'gs_driver_back'
  | 'gs_driver_front'
  | 'gs_recollect_purple'
  | 'gs_recollect'
  | 'gs_zap'
  | 'gs_clock_orange'
  | 'gs_tasks'
  | 'gs_visa'
  | 'gs_mastercard'
  | 'gs_icon_camera_access_denied'

const iconsMap = {
  gs_coins_add: RCgs_coins_add,
  gs_circle_check: RCgs_circle_check,
  gs_home_personal_feed: RCgs_home_personal_feed,
  gs_sleep: RCgs_sleep,
  gs_arrow_right_circle: RCgs_arrow_right_circle,
  gs_circle_info: RCgs_circle_info,
  gs_paper_plane_top_right_1: RCgs_paper_plane_top_right_1,
  gs_square_arrow_top_right_2: RCgs_square_arrow_top_right_2,
  gs_arrows_repeat_right_left_off: RCgs_arrows_repeat_right_left_off,
  gs_circle_x_1: RCgs_circle_x_1,
  gs_paper_plane_top_right: RCgs_paper_plane_top_right,
  gs_square_arrow_top_right: RCgs_square_arrow_top_right,
  gs_arrows_repeat_right_left: RCgs_arrows_repeat_right_left,
  gs_circle_x: RCgs_circle_x,
  gs_pencil: RCgs_pencil,
  gs_square_behind_square_2: RCgs_square_behind_square_2,
  gs_bubble_annotation_4: RCgs_bubble_annotation_4,
  gs_clock_blue: RCgs_clock_blue,
  gs_people_add_2: RCgs_people_add_2,
  gs_tag: RCgs_tag,
  gs_buildings: RCgs_buildings,
  gs_cross_large: RCgs_cross_large,
  gs_people_add: RCgs_people_add,
  gs_team: RCgs_team,
  gs_buildings_add: RCgs_buildings_add,
  gs_donut: RCgs_donut,
  gs_people_added: RCgs_people_added,
  gs_triangle_exclamation: RCgs_triangle_exclamation,
  gs_calendar_edit: RCgs_calendar_edit,
  gs_eye_open: RCgs_eye_open,
  gs_people: RCgs_people,
  gs_wallet_3: RCgs_wallet_3,
  gs_calender_remove: RCgs_calender_remove,
  gs_file_download: RCgs_file_download,
  gs_radio_active: RCgs_radio_active,
  gs_chevron_right_small: RCgs_chevron_right_small,
  gs_group_3: RCgs_group_3,
  gs_radio_default: RCgs_radio_default,
  gs_notepad: RCgs_notepad,
  gs_icon_clipboard: RCgs_icon_clipboard,
  gs_bank: RCgs_bank,
  gs_bgc: RCgs_bgc,
  gs_bookmark: RCgs_bookmark,
  gs_check: RCgs_check,
  gs_driver_back: RCgs_driver_back,
  gs_driver_front: RCgs_driver_front,
  gs_recollect_purple: RCgs_recollect_purple,
  gs_recollect: RCgs_recollect,
  gs_zap: RCgs_zap,
  gs_clock_orange: RCgs_clock_orange,
  gs_tasks: RCgs_tasks,
  gs_visa: RCgs_visa,
  gs_mastercard: RCgs_mastercard,
  gs_icon_camera_access_denied: RCgs_icon_camera_access_denied,
}

interface Props extends React.SVGProps<SVGSVGElement> {
  iconName: GSIconName
}

export const GSIcon = ({ iconName, ...props }: Props) => {
  const Icon = iconsMap[iconName]

  return <Icon {...props} />
}
